module.exports = __webpack_public_path__ + "e4b3a659f6cb1c8b0981a40409f21818.png";